export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1766224770683-8400e77db405?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxBSSUyMHJlc2VhcmNoJTIwbGFiJTIwd2hpdGUlMjBjbGVhbnxlbnwwfHx8fDE3ODcxNDc1MzN8MA&ixlib=rb-4.1.0&q=85",
  servicesTech: "https://images.pexels.com/photos/8439001/pexels-photo-8439001.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  aboutBuilding: "https://images.unsplash.com/photo-1765811998539-22fdb946f3be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBjbGVhbiUyMGxpZ2h0fGVufDB8fHx8MTc4NzE0NzUzM3ww&ixlib=rb-4.1.0&q=85",
  office: "https://images.pexels.com/photos/245219/pexels-photo-245219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  team: "https://images.unsplash.com/photo-1776273920142-f30bceff0cf3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwY2xlYW4lMjB3aGl0ZSUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg3MTQ3NTUxfDA&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_ITEMS = [
  "AI Readiness",
  "Strategy & Roadmaps",
  "Chatbots & Assistants",
  "Process Automation",
  "Team Training",
  "Data Insights",
  "Practical AI",
  "Measurable Results",
];

export const CHAPTERS = [
  {
    num: "01",
    title: "Understand first.",
    body: "Every engagement begins with your business, not our technology. We learn how your team actually works — the bottlenecks, the busywork, the budgets — before we recommend a single tool.",
  },
  {
    num: "02",
    title: "Results over hype.",
    body: "We measure success in hours saved and costs reduced, not in demos. If an AI tool cannot pay for itself within a year, we will tell you not to buy it.",
  },
  {
    num: "03",
    title: "Advisory without agenda.",
    body: "We sell judgment, not licences. Axiom holds no equity in the vendors we evaluate and takes no referral fees. Our only stake is the success of your business.",
  },
];

export const SERVICES = [
  {
    num: "01",
    title: "AI Readiness Assessment",
    desc: "A plain-English review of your business to find where AI can genuinely save time and money — and where it can't. You get a short report and a clear yes-or-no for each opportunity.",
    deliverables: ["Business process review", "Opportunity report", "Cost-benefit estimates", "Priority shortlist"],
  },
  {
    num: "02",
    title: "AI Strategy & Planning",
    desc: "A simple, budgeted roadmap for adopting AI in your business — which tools, in what order, at what cost, and what results to expect at each step.",
    deliverables: ["12-month AI roadmap", "Tool selection", "Budget planning", "Risk & privacy guidance"],
  },
  {
    num: "03",
    title: "Chatbots & Virtual Assistants",
    desc: "We set up AI chatbots for your website and customer support that answer common questions, book appointments, and hand over to your team when needed.",
    deliverables: ["Website chatbot setup", "FAQ & support bots", "Booking assistants", "Handover to staff"],
  },
  {
    num: "04",
    title: "Business Process Automation",
    desc: "Automate the repetitive work eating your team's week — data entry, invoice handling, email triage, report generation — using reliable, proven AI tools.",
    deliverables: ["Workflow automation", "Document processing", "Email & report automation", "System integration"],
  },
  {
    num: "05",
    title: "AI Training for Teams",
    desc: "Half-day and full-day workshops that teach your staff to use AI tools safely and effectively in their daily work — no technical background needed.",
    deliverables: ["Team workshops", "AI usage policies", "Hands-on practice", "Follow-up support"],
  },
];

export const PROCESS = [
  { num: "01", title: "Discover", body: "A short assessment. We learn how your business works and where AI can help most." },
  { num: "02", title: "Plan", body: "A simple roadmap: which tools, what they cost, and the results to expect." },
  { num: "03", title: "Implement", body: "We set everything up, connect it to your existing systems, and test it with your team." },
  { num: "04", title: "Support", body: "Training, check-ins, and ongoing help as your team gets comfortable." },
];

export const MEDIA_ITEMS = [
  {
    id: "fallback-meerut-studio",
    date: "Jul 2026",
    title: "Axiom Computers opens its consulting studio in Meerut, Delhi NCR",
    body: "Our new studio brings practical AI consulting closer to the businesses of North India — walk in with a problem, walk out with a plan.",
  },
  {
    id: "fallback-readiness-assessment",
    date: "Jun 2026",
    title: "Launching the AI Readiness Assessment for small businesses",
    body: "A fixed-scope, plain-English review that tells you exactly where AI will pay for itself in your business — and where it won't.",
  },
  {
    id: "fallback-parent-announcement",
    date: "May 2026",
    title: "Axiom Research and Development announces Axiom Computers",
    body: "Our parent company formalises its consulting arm, pairing computation engineering research with on-the-ground business advisory.",
  },
];

export const PRINCIPLES = [
  { num: "01", title: "Independence", body: "No vendor equity, no referral fees, no reselling. The firm is owned by its consultants." },
  { num: "02", title: "Rigour", body: "Every recommendation ships with its reasoning. Every tool ships with a way to measure it." },
  { num: "03", title: "Craft", body: "We are advisors who implement and trainers who stay. Both halves are non-negotiable." },
];
